import {
  chromeYellow, kiwiGreen, sanguine, spaceCadet, ultraMarine,
} from '@cogneed/react-utils';
import { createTheme } from '@mui/material';

const theme = createTheme({
  typography: {
    fontFamily: "'Source Sans Pro', 'Open Sans', sans-serif, Roboto",
  },
  palette: {
    background: {
      default: '#ffffff',
    },
    primary: {
      light: ultraMarine[300],
      main: ultraMarine[500],
      dark: ultraMarine[700],
    },
    secondary: {
      light: spaceCadet[300],
      main: spaceCadet[500],
      dark: spaceCadet[800],
    },
    warning: {
      light: chromeYellow[300],
      main: chromeYellow[500],
      dark: chromeYellow[700],
    },
    error: {
      light: sanguine[300],
      main: sanguine[500],
      dark: sanguine[700],
    },
    success: {
      light: kiwiGreen[300],
      main: kiwiGreen[500],
      dark: kiwiGreen[700],
    },
  },
  components: {
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontWeight: 700,
          fontSize: 20,
          lineHeight: '32px',
        },
      },
    },
    MuiInputAdornment: {
      styleOverrides: {
        positionStart: {
          marginLeft: 0,
          marginRight: 0,
        },
        root: {
          color: spaceCadet[400],
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        standardSuccess: {
          backgroundColor: kiwiGreen[100],
          color: kiwiGreen[600],
          '& .MuiSvgIcon-root': {
            color: kiwiGreen[600],
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        containedSecondary: {
          boxShadow: 'none',
          color: spaceCadet[800],
          backgroundColor: chromeYellow[500],
          fontSize: 14,
          fontWeight: 600,
          padding: '10px 12px',
          lineHeight: '20px',
          textTransform: 'none',
          '&:hover': {
            backgroundColor: chromeYellow[600],
            boxShadow: 'none',
          },

          '&:disabled': {
            color: spaceCadet[800],
            backgroundColor: chromeYellow[500],
            opacity: 0.2,
          },
        },
        containedError: {
          color: spaceCadet[100],
          backgroundColor: sanguine[500],
          fontSize: 14,
          fontWeight: 600,
          padding: '10px 12px',
          lineHeight: '20px',
          textTransform: 'none',
          '&:hover': {
            backgroundColor: sanguine[600],
          },
          '&:disabled': {
            color: sanguine[100],
            backgroundColor: sanguine[500],
            opacity: 0.2,
          },
        },
        containedPrimary: {
          color: spaceCadet[100],
          backgroundColor: ultraMarine[500],
          fontSize: 14,
          fontWeight: 600,
          padding: '10px 12px',
          textTransform: 'none',
          lineHeight: '20px',

          '&:hover': {
            backgroundColor: ultraMarine[600],
          },

          '&:disabled': {
            color: spaceCadet[100],
            backgroundColor: ultraMarine[500],
            opacity: 0.2,
          },
        },
        outlinedPrimary: {
          '&:disabled': {
            color: ultraMarine[500],
            opacity: 0.5,
          },
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          fontFamily: "'Source Sans Pro', 'Open Sans', sans-serif, Roboto",
          textTransform: 'none',
          letterSpacing: 0,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
});
export default theme;
